import { energyPriceApi } from 'src/components/PromotionalIntegrations/Verivox/api/verivoxApi';
import { isVerivoxSurfaceDismissed } from 'src/components/PromotionalIntegrations/Verivox/utils/verivoxDismissals';
import { isEnergyPriceFeatureEnabled } from 'src/helpers/energy_price_helpers';
import type { VerivoxDismissSurface } from 'src/components/PromotionalIntegrations/Verivox/utils/verivoxDismissals';

/** True when the user has a completed Verivox location (postal + location id). */
export const hasCompletedVerivoxLocation = (): boolean => {
	const location = energyPriceApi.getCachedLocation();
	return Boolean(location?.postalCode && location?.locationId);
};

/**
 * Whether Verivox may appear in BannersWidget / GlobalInlineBanners.
 * Requires backend `de_users` or Dev Modal force-enable (see isEnergyPriceFeatureEnabled).
 * Generic sample promos are independent and do not use this gate.
 */
export const isVerivoxEligibleForDashPromos = (): boolean => isEnergyPriceFeatureEnabled();

/**
 * Whether the Verivox setup promo banner should show on a given surface.
 * Requires feature access, no completed location, and surface not dismissed.
 */
export const shouldShowVerivoxPromoBanner = (
	surface: VerivoxDismissSurface = 'notifications',
): boolean => {
	return (
		isEnergyPriceFeatureEnabled() &&
		!hasCompletedVerivoxLocation() &&
		!isVerivoxSurfaceDismissed(surface, 'setup')
	);
};

/**
 * Whether the post-setup Verivox offers banner should show.
 * Requires feature access, completed location, and surface not dismissed.
 */
export const shouldShowVerivoxOffersBanner = (
	surface: VerivoxDismissSurface = 'notifications',
): boolean => {
	return (
		isEnergyPriceFeatureEnabled() &&
		hasCompletedVerivoxLocation() &&
		!isVerivoxSurfaceDismissed(surface, 'offers')
	);
};

/** @deprecated Use hasCompletedVerivoxLocation */
export const hasCompletedEnergyPriceLocation = hasCompletedVerivoxLocation;

/** @deprecated Use shouldShowVerivoxPromoBanner */
export const shouldShowEnergyPricePromoBanner = shouldShowVerivoxPromoBanner;

/** @deprecated Use shouldShowVerivoxOffersBanner */
export const shouldShowEnergyPriceOffersBanner = shouldShowVerivoxOffersBanner;
